import {IDocumentState} from "./document-state.store";
import {ActionTree} from "vuex";
import {IRootState} from "../root-state.store";
import * as _ from "./document-types.store";
import {DOCUMENT_GET_ATTACHMENT_TYPES} from "./document-types.store";
import { IDocumentParamter, IDocumentModel } from "../../models/documents";
import { ActivityStatus, CrudStatus } from "../../common/enums";
import { IDocument } from "../../models/documents/document";
import { IDocumentService } from "../../services";
import {DOCUMENT_SEND_TICKET_DOCUMENT} from "./document-types.store";

export const actions: ActionTree<IDocumentState, IRootState> = {
  [_.DOCUMENT_GET_DOCUMENTS]: async ({commit, state}, payload?: { blockId: string, param: IDocumentParamter }) => {

    if (state.activityStatus === ActivityStatus.Loading) {
      return;
    }

    commit(_.DOCUMENT_GET_DOCUMENTS_LOADING, ActivityStatus.Loading)

    return await state.service.getDocuments(payload.blockId, payload.param)
      .then(res => {
        commit(_.DOCUMENT_SET_DOCUMENTS, res)
        return res;
      })
      .catch(error => {
        commit(_.DOCUMENT_GET_DOCUMENTS_LOADING, ActivityStatus.LoadFailed)
        return error;
      })
  }
  ,
  [_.DOCUMENT_DOWNLOAD_DOCUMENTS]: async ({commit, state}, payload?: {param: IDocumentParamter }) => {

    return await state.service.downloadDocuments(payload)
      .then(res => {
        return res;
      })
      .catch(error => {
        return error;
      })
  },
  [_.DOCUMENT_GET_DOCUMENTS_ATTACHMENTS]: async ({commit, state}) => {
    let params: any = {}
    params.attributeFilters = state.documentParameter.attributeFilters
    if (state.documentParameter.block && state.documentParameter.block.length)
      params.block = state.documentParameter.block.join(',')
    if (state.documentParameter.apartment && state.documentParameter.apartment.length)
      params.apartment = state.documentParameter.apartment.join(',')
    if (state.documentParameter.creator && state.documentParameter.creator.length)
      params.entity = state.documentParameter.creator.join(',')
    if (state.documentParameter.fk_attachment_type && state.documentParameter.fk_attachment_type.length)
      params.attachment_type = state.documentParameter.fk_attachment_type.join(',')
    if (state.documentParameter.fk_attachment_type_level_2 && state.documentParameter.fk_attachment_type_level_2.length)
      params.attachment_type_2 = state.documentParameter.fk_attachment_type_level_2.join(',')
    if (state.documentParameter.key)
      params.key = state.documentParameter.key
    if (params.key || params.attachment_type || state.documentParameter.detail) {
      params.$skip = (state.pagination.page - 1) * 10
    }
    if (state.documentParameter.$limit) {
      params.$limit = state.documentParameter.$limit
    }
    if (state.documentParameter.detail) {
      params.detail = state.documentParameter.detail
    }
    if (state.documentParameter.orderKeys) {
      params.orderKeys = state.documentParameter.orderKeys.join(',')
    }
    if (state.documentParameter.orderValues) {
      params.orderValues = state.documentParameter.orderValues.join(',')
    }
    if (state.documentParameter.equipment) {
      params.equipment = state.documentParameter.equipment.join(',')
    }

    commit(_.DOCUMENT_SET_LOADER_STATE, {key: _.DOCUMENT_LOADERS.TABLE_LOADER, value: true})
    return await state.service.getDocumentAttachments(params)
      .then((res: any) => {
        commit(_.DOCUMENT_SET_DOCUMENTS_PAGINATION, {total_pages: res.total, total:res.total})
        commit(_.DOCUMENT_SET_DOCUMENTS, res.data)
        return res
      })
      .catch(error => {
        console.log(error)
        return error
      })
      .finally(() => {
        commit(_.DOCUMENT_SET_LOADER_STATE, {key: _.DOCUMENT_LOADERS.TABLE_LOADER, value: false})
      })
  }
  ,
  [_.DOCUMENT_GET_DOCUMENT_TYPES]: async ({commit, state}) => {

    if (state.documentTypes && state.documentTypes.length) return state.documentTypes

    if (state.sidebarDocumentTypeActivityStatus === ActivityStatus.Loading) {
      return;
    }

    commit(_.DOCUMENT_GET_DOCUMENTS_TYPE_LOADING, ActivityStatus.Loading)
    commit(_.DOCUMENT_SET_LOADER_STATE, {key: _.DOCUMENT_LOADERS.CATEGORIES_LOADER, value: true})
    return await state.service.getDocumentTypes()
      .then(res => {
        commit(_.DOCUMENT_GET_DOCUMENT_TYPES, res)
        return res;
      })
      .catch(error => {
        commit(_.DOCUMENT_GET_DOCUMENTS_TYPE_LOADING, ActivityStatus.LoadFailed)
        return error;
      })
      .finally(() => commit(_.DOCUMENT_SET_LOADER_STATE, {key: _.DOCUMENT_LOADERS.CATEGORIES_LOADER, value: false}))
  }
  ,
  [_.DOCUMENT_GET_ATTACHMENT_TYPES]: async ({commit, state}, id: any = null) => {
    return state.service.getAttachmentTypes(id)
  }
  ,
  [_.DOCUMENT_GET_DOCUMENTS_SIDEBAR]: async ({
                                               commit,
                                               state
                                             }, payload: { blockId: string, param: IDocumentParamter, force?: boolean }) => {

    if (state.activityStatus === ActivityStatus.Loading) {
      return;
    }

    commit(_.DOCUMENT_GET_DOCUMENTS_SIDEBAR_LOADING, ActivityStatus.Loading)

    return await state.service.getDocuments(payload.blockId, payload.param)
      .then(res => {
        commit(_.DOCUMENT_GET_DOCUMENTS_SIDEBAR, res)
        return res;
      })
      .catch(error => {
        commit(_.DOCUMENT_GET_DOCUMENTS_SIDEBAR_LOADING, ActivityStatus.LoadFailed)
        return error;
      })
  }
  ,
  [_.DOCUMENT_RECORD_DOCUMENT]: async ({commit, state}, payload: { blockId: string, files: IDocumentModel[] }) => {
    return await state.service.recordDocument(payload.blockId, payload.files)
      .then(res => {
        commit(_.DOCUMENT_GET_DOCUMENTS_SIDEBAR, res)
        return res;
      })
      .catch(err => {
        console.log(err)
        return err;
      })
  }
  ,
  [_.DOCUMENT_SAVE_DOCUMENT]: async ({commit, getters}) => {
    const service: IDocumentService = getters!.service
    commit(_.DOCUMENT_SET_LOADER_STATE, {key: _.DOCUMENT_LOADERS.TABLE_LOADER, value: true})
    return service.saveDocument(getters.document)
      .then(response => {
        commit(_.DOCUMENT_INIT_DOCUMENT, service.initDocument({}))
        commit(_.DOCUMENT_SET_DOCUMENT_ACTION, CrudStatus.NoAction)
        return Promise.resolve(response)
      })
      .catch(err => Promise.reject(err))
  }
  , [_.DOCUMENT_SEND_TICKET_DOCUMENT]: async ({ commit, getters, state}, payload: { ticketId: string, channelId: string }) => {
    return state.service.saveTicketDocument(payload.ticketId, payload.channelId, getters.document)
      .then(response => {
        commit(_.DOCUMENT_INIT_DOCUMENT,state.service.initDocument({}))
        return Promise.resolve(response)
      })
      .catch( err=> Promise.reject(err))
  }
  , [_.DOCUMENT_EDIT_DOCUMENT]: async ({ commit, getters },id: number) => {
    const service: IDocumentService= getters.service
    const document= getters.documents.find(document=> document.id === id)
    commit(_.DOCUMENT_INIT_DOCUMENT,service.initDocument({
      id,
      type: document.fk_attachment_type,
      typeLvl2: document.fk_attachment_type_level_2,
      name: document.name,
      blocks: document.blocks,
      apartments: document.apartments,
      equipments:document.equipments,
      entities: document.entities.map(entity => entity.entity_id),
      share: document.sharing_type,
      all_block:document.all_block,
      sharing_role:document.sharing_role.map(item=>item.id),
      attachments: [{
        name: document.name,
        reference: document.reference,
        file: document.link,
        attributes: document.attributes.map(x => ({
          fk_attribute: x.id,
          value: x.attribute_value ? x.attribute_value.value : null
        }))
      }]
    }))
    commit(_.DOCUMENT_SET_DOCUMENT_ACTION, CrudStatus.Update)
  },
  [_.EQUIPMENT_EDIT_DOCUMENT]: async ({ commit, getters },doc: any) => {
    const service: IDocumentService= getters.service
    const document= doc
    commit(_.DOCUMENT_INIT_DOCUMENT,service.initDocument({
      id: document.id,
      type: document.fk_attachment_type,
      typeLvl2: document.fk_attachment_type_level_2,
      name: document.name,
      blocks: document.blocks,
      apartments: document.apartments,
      equipments: document.equipments,
      entities: document.entities.map(entity => entity.entity_id),
      share: document.sharing_type,
      attachments: [{
        name: document.name,
        reference: document.reference,
        file: document.link,
        attributes: document.attributes.map(x => ({
          fk_attribute: x.id,
          value: x.attribute_value ? x.attribute_value.value : null
        }))
      }]
    }))
    commit(_.DOCUMENT_SET_DOCUMENT_ACTION, CrudStatus.Update)
  }
  ,
  [_.DOCUMENT_UPDATE_DOCUMENT]: async ({commit, getters}) => {
    commit(_.DOCUMENT_SET_LOADER_STATE, {key: _.DOCUMENT_LOADERS.TABLE_LOADER, value: true})
    const service: IDocumentService = getters!.service
    return service.updateDocument(getters.document)
      .then(response => {
        commit(_.DOCUMENT_INIT_DOCUMENT, service.initDocument({}))
        commit(_.DOCUMENT_SET_DOCUMENT_ACTION, CrudStatus.NoAction)
        return Promise.resolve(response)
      })
      .catch(err => Promise.reject(err))
  }
  ,
  [_.DOCUMENT_DELETE_DOCUMENT]: async ({commit, state, dispatch}, id: string) => {
    commit(_.DOCUMENT_DELETE_DOCUMENT_LOADING, ActivityStatus.Loading)
    return await state.service.removeDocument(id)
      .then(res => {
        commit(_.DOCUMENT_DELETE_DOCUMENT, id)
        return res;
      })
      .catch(res => {
        commit(_.DOCUMENT_DELETE_DOCUMENT_LOADING, ActivityStatus.LoadFailed)
      })
  }
  ,
  [_.DOCUMENT_REMOVE_DOCUMENT]: async ({commit, getters}) => {
    const service: IDocumentService = getters.service
    const documentSelection: number[] = getters.documentSelection
    commit(_.DOCUMENT_SET_LOADER_STATE, {key: _.DOCUMENT_LOADERS.TABLE_LOADER, value: true})
    return Promise.all(documentSelection.map(selection => service.deleteDocument(selection)))
      .then(responses => {
        commit(_.DOCUMENT_INIT_DOCUMENT_SELECTION)
        return Promise.resolve(responses)
      })
      .catch(err => Promise.reject(err))
      .finally(() => commit(_.DOCUMENT_SET_DOCUMENT_ACTION, CrudStatus.NoAction))
  }
  ,
  [_.DOCUMENT_RESET_DOCUMENT]: async ({commit, state}, payload?: IDocument) => {
    if (!payload) payload = {}
    commit(_.DOCUMENT_INIT_DOCUMENT, state.service.initDocument(payload))
    commit(_.DOCUMENT_SET_DOCUMENT_ACTION, CrudStatus.NoAction)
  },
  [_.DOCUMENT_GET_DOC_BY_ID]: async ({state}, payload: { id: string }) => {
    return state.service.getDocById(payload.id)
  }
}



// WEBPACK FOOTER //
// ./src/store/document/document-actions.store.ts